// extracted by mini-css-extract-plugin
export default {"userTitle":"BuiltByBadge_userTitle__pfeVX","avatar":"BuiltByBadge_avatar__aGvIN"};